module.exports = __webpack_public_path__ + "static/media/logo.e311bf2c.png";